import { Component, DestroyRef, HostBinding, inject, OnInit } from '@angular/core';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { filter, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { checkRouterChildsData } from '@vex/utils/check-router-childs-data';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SecurityService } from 'src/services/security/security.service';

@Component({
  selector: 'vex-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatIconModule, RouterLink, AsyncPipe]
})

export class ToolbarComponent implements OnInit {
  @HostBinding('class.shadow-b')
  showShadow: boolean = false;

  isDesktop$: Observable<boolean> = this.layoutService.isDesktop$;
  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  constructor(
    private readonly layoutService: VexLayoutService,
    private readonly router: Router,
    protected securityService: SecurityService
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.showShadow = checkRouterChildsData(
          this.router.routerState.root.snapshot,
          (data) => data.toolbarShadowEnabled ?? false
        );
      });
  }

  openSidenav(): void {
    this.layoutService.openSidenav();
  }
}
